import { render, staticRenderFns } from "./MediumCard.vue?vue&type=template&id=77979037&scoped=true&"
import script from "./MediumCard.vue?vue&type=script&lang=js&"
export * from "./MediumCard.vue?vue&type=script&lang=js&"
import style0 from "./MediumCard.vue?vue&type=style&index=0&id=77979037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77979037",
  null
  
)

export default component.exports